import '@splidejs/splide/dist/css/splide.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import { BenBase } from './js/BenBase'
const el = document.createElement('div')
el.id = 'app'
document.querySelector('body')?.append(el)
const app = createApp(App).mount(el)
BenBase.init(app as any)
